import { createAction, props } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { PromocodeBanner } from '../types';

export const LoadPromocodeBanners = createAction(
  '[PromocodeBanner] Load Promocode Banners',
);

export const LoadPromocodeBannersSucces = createAction(
  '[PromocodeBanner] Load Promocode Banners Success',
  props<{
    promocodeBanners: PromocodeBanner[];
  }>(),
);

export const LoadPromocodeBannersFail = createAction(
  '[PromocodeBanner] Load Promocode Banners Fail',
  props<HttpError>(),
);
